export default __webpack_public_path__ + "static/media/four-digits-black.78859ead.svg";